var exports = {
  "kL": "xfd349460--9465e9--container",
  "Zp": "xfd349460--9465e9--layout",
  "sT": "xfd349460--9465e9--promo",
  "ey": "xfd349460--9465e9--previews",
};

module.exports = exports;
